import React from 'react'
import styled from 'styled-components'
import { Grid as BaseGrid, Hidden as BaseHidden } from '@material-ui/core'

export const Root = styled.div`
  margin: 0;
  width: 100%;
`

export const Actions = styled.div`
  margin-top: 28px;
`

export const Title = styled.h1`
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 34px;
  font-weight: 300;
  line-height: 45px;

  ${props => props.theme.breakpoints.down('xs')} {
    text-align: center;
  }
`

export const Image = styled.img`
  height: ${props => props.height || '100%'};
`

export const Conditions = styled.div`
  font-size: 13px;
  font-weight: 300;
  line-height: 18px;
  margin-left: -10px;
  margin-top: 25px;

  ${props => props.theme.breakpoints.down('xs')} {
    text-align: center;
  }
`

export const TermsLink = styled.a``

export const Instructions = styled.section`
  font-size: 22px;
  font-weight: 300;
  line-height: 26px;
  margin-top: 28px;

  ${props => props.theme.breakpoints.down('xs')} {
    text-align: center;
  }
`

export const Section = styled(({ margin, maxWidth, padding, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin || 'initial'};
  max-width: ${props => props.maxWidth || 'initial'};
  padding: ${props => props.padding || '0'};
`

export const Hidden = styled(BaseHidden)``

export const DesktopNavigation = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 30px;
  margin: 0;
  width: 100%;
`

export const MobileNavigation = styled.div`
  align-items: center;
  background-color: ${props => props.theme.palette.custom.ghostWhite};
  bottom: 0;
  box-shadow: 0 -3px 10px ${props => props.theme.palette.custom.ghostBlack};
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 32px;
  height: ${props => (props.dniTestFeatureEnabled ? '160px' : '90px')};
  justify-content: center;
  left: 0;
  position: fixed;
  width: 100%;
`
